import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { createContext, useContext, useMemo } from 'react';
const context = createContext(null);
const FieldContextRoot = styled.div `
  display: flex;
  flex-flow: row;
  min-width: 0;
  margin: 0;
  padding: 0;
  gap: 5px;
`;
const Label = styled.label `
  position: relative;
  display: inline-flex;
  max-width: 100%;
  line-height: ${(props) => (props.variant === 'small' ? '28px' : '32px')};
  font-size: ${(props) => (props.variant === 'small' ? '1em' : '1.125em')};
  white-space: nowrap;
  text-align: end;
`;
const LabelContainer = styled.div `
  flex-grow: 0;
  display: inline-block;
  overflow: hidden;
  text-align: end;
  vertical-align: middle;
  white-space: nowrap;
`;
const FieldContextRequired = styled.span `
  color: red;
`;
export function useFieldsContext() {
    const ctx = useContext(context);
    if (!ctx) {
        return { name: undefined, variant: 'default' };
    }
    return ctx;
}
export function Field(props) {
    const { label, name, children, required, variant } = props;
    const memoized = useMemo(() => {
        return { name, variant: variant || 'default' };
    }, [name, variant]);
    return (_jsx(context.Provider, { value: memoized, children: _jsxs(FieldContextRoot, { children: [_jsx(LabelContainer, { children: _jsxs(Label, { htmlFor: name, variant: memoized.variant, children: [label, " ", required && _jsx(FieldContextRequired, { children: "*" }), ":", ' '] }) }), children] }) }));
}
//# sourceMappingURL=FieldsContext.js.map